import { Badge } from '@shared/ui';

import { VERDICT_REASON } from './verdict-reason';

import type { FlagVerdict } from '../schemas/flag';

/**
 * The verdict, with the sentence that says where it came from beside it.
 *
 * The sentences themselves live in `verdict-reason.ts` — both because two
 * screens read the same verdict from opposite ends and must say the same thing,
 * and because a file that exports a component alongside a constant cannot be
 * hot-swapped by Fast Refresh.
 */
export function VerdictBadge({ verdict }: { verdict: FlagVerdict }) {
    return (
        <span className="inline-flex items-center gap-2">
            <Badge tone={verdict.enabled ? 'success' : 'neutral'} dot>
                {verdict.enabled ? 'On' : 'Off'}
            </Badge>
            <span className="text-xs text-content-muted">{VERDICT_REASON[verdict.source]}</span>
        </span>
    );
}
